export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6" data-testid={testId}>
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-midnight uppercase leading-none">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
